import React, { useState } from 'react';
import { signInWithGoogle, signInWithMicrosoft } from '../AuthContext';

// "Continue with Google / Microsoft" — both providers assert a verified
// email, so a work account arrives verified with no link to click. Redirect
// flow; the result lands in onAuthStateChanged like any other sign-in.
export default function OAuthButtons({ disabled = false, onError, label = 'Continue with' }) {
  const [busy, setBusy] = useState('');
  const go = async (which) => {
    setBusy(which);
    try {
      await (which === 'google' ? signInWithGoogle() : signInWithMicrosoft());
    } catch (err) {
      setBusy('');
      if (onError) onError(err.message);
    }
  };
  return (
    <div style={{ display: 'grid', gap: 8, marginBottom: 14 }}>
      <button type="button" className="cs-btn cs-btn-outline" style={{ width: '100%' }} disabled={disabled || !!busy} onClick={() => go('google')}>
        {busy === 'google' ? 'Redirecting…' : `${label} Google`}
      </button>
      <button type="button" className="cs-btn cs-btn-outline" style={{ width: '100%' }} disabled={disabled || !!busy} onClick={() => go('microsoft')}>
        {busy === 'microsoft' ? 'Redirecting…' : `${label} Microsoft`}
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--muted)', fontSize: 12 }}>
        <span style={{ flex: 1, height: 1, background: 'var(--border, rgba(255,255,255,.12))' }} />
        or with email
        <span style={{ flex: 1, height: 1, background: 'var(--border, rgba(255,255,255,.12))' }} />
      </div>
    </div>
  );
}
